module.exports = __webpack_public_path__ + "static/img/Vector1.8003690e.svg";